var FacebookUpload = {
	
	uploadImage : function( blob, message ) {
	
		FB.getLoginStatus( function( response ) {
			if(response.status === "connected" ) {
				FacebookUpload.postImageToFacebook(response.authResponse.accessToken,blob,message);
			}
			else if (response.status === "not_authorized" ) {
				FB.login(function(response) {
				FacebookUpload.postImageToFacebook(response.authResponse.accessToken,blob,message);
			},{scope: "publish_actions"});
			
			} else {
				FB.login( function( response )  {
				FacebookUpload.postImageToFacebook(response.authResponse.accessToken,blob,message);
				}, { scope : "publish_actions" } );
			}});
	},

	postImageToFacebook : function ( authToken, blob, message ){
		var fd = new FormData();
		fd.append( "access_token" ,authToken );
		fd.append( "source", blob );
		fd.append( "message", localisation.social.facebook.message );
		fd.append( "allow_spherical_photo", true );
		try {
			$.ajax({
				url : "https://graph.facebook.com/me/photos?access_token=" + authToken,
				type : "POST",
				data : fd,
				processData : false,
				contentType : false,
				cache : false,




				success : function( data ){
					app.dispatcher.dispatch( EVENTS.SHARE_IMAGE_FB_DONE, "success" );
				},

				error : function( shr, status, data ){
					app.dispatcher.dispatch( EVENTS.SHARE_IMAGE_FB_DONE, "error" );
					console.log( "error " + data + " Status " + shr.status );
				},
				
				complete : function(){
					//app.dispatcher.dispatch( EVENTS.SHARE_IMAGE_FB_DONE, "success" );
				}
			});
		}
		catch( e ) {
			console.log( e );
		}
	}
};

